<template>
  <div>
    <vs-button @click="popupActive=true">
      Compare Old & New
    </vs-button>

    <vs-popup class="holamundo" title="Compare Values" :active.sync="popupActive">
      <div class="vs-row">
        <div class="vs-col w-1/2">
          <h3>Old Values</h3>
          <br>
          <pre><code>{{ params.data.old_values }}</code></pre>
        </div>
        <div class="vs-col w-1/2">
          <h3>New Values</h3>
          <br>
          <pre><code>{{ params.data.new_values }}</code></pre>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data () {
    return {
      popupActive: false
    }
  }
}
</script>